var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.pageSettings)?_c('div',{ref:"mapContainer",staticClass:"map-container"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }